import { ReckoningModel } from '../Reckoning/ReckoningModel';
import { types } from 'mobx-state-tree';

const RecommendedPageModel = types.model('RecommendedPageModel', {
  recommendationStrategy: types.maybeNull(types.string),
  feature: types.maybeNull(types.string),
});

export const UserModel = types.model('UserModel', {
  _id: types.identifier,
  firstName: types.string,
  email: types.maybeNull(types.string),
  phoneNumber: types.maybeNull(types.string),
  region: types.maybeNull(types.string),
  language: types.string,
  oneSignalExternalIdToken: types.maybeNull(types.string),
  oneSignalEmailToken: types.maybeNull(types.string),
  reckoning: types.maybeNull(ReckoningModel),
  company: types.maybeNull(types.string),
  companyName: types.maybeNull(types.string),
  MHCNextDate: types.maybeNull(types.string),
  name: types.optional(types.string, ''),
  profileImage: types.optional(types.maybeNull(types.string), ''),
  role: types.optional(types.string, ''),
  permissions: types.optional(types.array(types.string), []),
  tokenExpires: types.maybeNull(types.number),
  iat: types.maybeNull(types.number),
  onboardingDone: types.maybeNull(types.boolean),
  redoSessionDone: types.maybeNull(types.boolean),
  matchingSurveyDone: types.maybeNull(types.boolean),
  registeredWithWpo: types.maybeNull(types.boolean),
  oneSignalTags: types.maybeNull(types.string),
  recommendedPages: types.maybeNull(RecommendedPageModel),
});
